import { UserPropsType } from '../../../../../Type/Application/Users/UsersProfile'
import { Col, Row } from 'reactstrap'
import { H4, Image } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Service'

const CommonProfileHead = ({ activeTime }: UserPropsType) => {
  return (
    <Row>
      <Col sm="8">
        <div className="d-flex">
          <Image className="img-thumbnail rounded-circle me-3" src={dynamicImage('user/7.jpg')} alt="GenericPlaceholder" />
          <div className="flex-grow-1 align-self-center">
            <H4 className="mt-0 user-name">{'JOHAN DIO'}</H4>
          </div>
        </div>
      </Col>
      <Col sm="4" className="align-self-center">
        <div className="float-sm-end">
          <small>{activeTime}</small>
        </div>
      </Col>
    </Row>
  )
}

export default CommonProfileHead